<template>
  <div>
    <div class="row filters mb-4">
      <div class="col-2">
        <b-field>
          <app-autocomplete
            placeholder="Filtrar por Rede"
            field="name"
            :searchFunction="searchNetworkFn"
            :resourceIdFunction="resourceNetworkFn"
            v-model="filters.network_id"
            @selected="load"
          ></app-autocomplete>
        </b-field>
      </div>
      <div class="col-4">
        <app-input
          @input="onInput"
          v-model="filters.term"
          placeholder="Pesquisar"
        ></app-input>
      </div>
    </div>

    <b-table
      :data="data"
      :loading="loading"
      paginated
      backend-pagination
      :total="total"
      :per-page="perPage"
      @page-change="onPageChange"
      aria-next-label="Próxima Página"
      aria-previous-label="Página Anterior"
      aria-page-label="Página"
      aria-current-label="Página Atual"
    >
      <template slot-scope="props">
        <b-table-column field="id" label="#" numeric>
          {{ props.row.id }}
        </b-table-column>

        <b-table-column field="network" label="Rede">
          {{ props.row.network.name }}
        </b-table-column>

        <b-table-column field="cnpj" label="CNPJ">
          {{ props.row.cnpj | VMask('##.###.###/####-##') }}
        </b-table-column>

        <b-table-column field="name" label="Nome">
          {{ props.row.name || '-' }}
        </b-table-column>

        <b-table-column field="email" label="E-mail">
          {{ props.row.email || '-' }}
        </b-table-column>

        <b-table-column label="Opções">
          <button
            @click="edit(props.row.id)"
            v-app-button.icon-only
            v-tooltip.bottom="'Editar'"
          >
            <b-icon size="is-small" icon="pencil"></b-icon>
          </button>
          <button
            @click="onClickDeleteUnit(props.row.id)"
            v-app-button.icon-only
            v-tooltip.bottom="'Excluir'"
            color="danger"
          >
            <b-icon size="is-small" icon="delete"></b-icon>
          </button>
        </b-table-column>
      </template>

      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large"></b-icon>
            </p>
            <p>Nenhum registro encontrado.</p>
          </div>
        </section>
      </template>
    </b-table>
  </div>
</template>

<script>
import NetworkService from '@/services/network.service';
import UnitService from '@/services/unit.service';
import ToastMixin from '@/mixins/ToastifyMixin';
import debounce from 'lodash/debounce';

export default {
  name: 'units-table',
  mixins: [ToastMixin],
  data: () => {
    return {
      data: [],
      total: 0,
      loading: false,
      page: 1,
      perPage: 10,
      filters: {},
    };
  },
  methods: {
    load() {
      this.loading = true;

      UnitService.get({
        page: this.page,
        perPage: this.perPage,
        ...this.filters,
      })
        .then((response) => {
          const { total, data } = response.data;

          this.total = total;
          this.data = data;
        })
        .catch(() => this.toastify('Erro ao carregar Unidades.', 'error'))
        .finally(() => (this.loading = false));
    },
    edit(id) {
      this.$router.push(`${id}/edit`);
    },
    onClickDeleteUnit(id) {
      this.$buefy.dialog.confirm({
        title: 'Excluindo Unidade',
        message:
          'Tem certeza que deseja <b>excluir</b> esta unidade? Essa ação não pode ser desfeita.',
        cancelText: 'Cancelar',
        confirmText: 'Excluir Unidade',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.deleteUnit(id),
      });
    },
    deleteUnit(id) {
      UnitService.delete(id)
        .then(() => {
          this.toastify('Unidade excluída com sucesso.');
          this.load();
        })
        .catch(({ response }) => {
          this.toastify(
            response.data.message || 'Erro ao tentar excluir Unidade.',
            'error'
          );
        });
    },
    onPageChange(page) {
      this.page = page;
      this.load();
    },
    onInput: debounce(function () {
      this.load();
    }, 400),
    searchNetworkFn: NetworkService.search,
    resourceNetworkFn: NetworkService.getId,
  },
  mounted() {
    if (localStorage.unitsTableNetworkId) {
      this.filters = {
        ...this.filters,
        network_id: localStorage.unitsTableNetworkId,
      };
    }

    if (localStorage.unitsTableTerm) {
      this.filters = {
        ...this.filters,
        term: localStorage.unitsTableTerm,
      };
    }

    this.load();
  },
  watch: {
    'filters.network_id': (newValue) => {
      localStorage.unitsTableNetworkId = newValue || '';
    },
    'filters.term': (newValue) => {
      localStorage.unitsTableTerm = newValue;
    },
  },
};
</script>
